import React, { Component } from 'react';

import InscricaoSmall from './InscricaoSmall';


import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

const titleStyle = {
  fontSize: '16px',
  fontWeight: 700
}

const estaPago = {
  color: '#529a76',
  marginRight: '12px',
  marginLeft: '12px'
}

const naoEstaPago = {
  color: '#D9534F'
}


class DetalhesInscricao extends Component {

  constructor(props) {
    super(props);

    this.state = {
      evento: {},
      modalIsOpen: false,
      detalhesEventoIsOpen: true
    };

    this.handleChange = this.handleChange.bind(this); 
    
    
  }

    handleChange = (field) => {
      this.setState({field: !field})
    }

    render() {

      

        return (
            <React.Fragment>
                  <p style={titleStyle}>Reservas do evento <span style={estaPago}>| Está pago</span> <span style={naoEstaPago}>| Não está pago</span></p>
                  

                  <Table className="backoffice-table">
                    <TableHead className="table-header">
                      <TableRow>
                        <TableCell>Nome reserva</TableCell>
                        <TableCell>Email reserva</TableCell>
                        <TableCell>Número Participantes</TableCell>
                        <TableCell>Data reserva</TableCell>
                        <TableCell />
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {
                        this.props.evento.inscricoes.map(function(item){
                          return(<InscricaoSmall inscricao={item} key={item._id} evento={this.props.evento.identifier}></InscricaoSmall>)
                        }.bind(this))
                      }
                    </TableBody>
                  </Table>
                   


                </React.Fragment>
        );
    }
}

export default DetalhesInscricao;